import SearchAndFilters from 'components/SearchAndFilters';
import { FilterConfig } from 'components/SearchAndFilters/FilterTypes';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { Suspense } from 'react';
import { Row, Col } from 'reactstrap';
import { companyIdAtom } from 'views/state';
import {
  checkedListAtom,
  filterValuesAtom,
  orderbyAtom,
  useOnFilterChangeResetAtoms,
} from './state';
import { useWAListFilterValue } from '../hooks';

const Filters: React.FC<{ filtersConfig: FilterConfig }> = ({
  filtersConfig,
}) => {
  const orderBy = useAtomValue(orderbyAtom);
  const companyId = useAtomValue(companyIdAtom);
  const selectedRowIds = useAtomValue(checkedListAtom);
  const setFilterValues = useSetAtom(filterValuesAtom);
  const searchPhrase = useWAListFilterValue<string>('search');
  const selectedWebAppsFilter = useWAListFilterValue<
    'active' | 'inactive' | 'deleted'
  >('filter');
  const resetOnFilterChangeAtoms = useOnFilterChangeResetAtoms();
  const handleFilterChange = () => {
    setFilterValues({ ...filtersConfig.getActiveFilterValues() });
    resetOnFilterChangeAtoms();
  };

  return (
    <Suspense fallback={<></>}>
      <Row className="text-left">
        <Col xs="12" md>
          <SearchAndFilters
            config={filtersConfig}
            onChange={handleFilterChange}
          />
        </Col>
      </Row>
    </Suspense>
  );
};

export default Filters;
